import React from "react";
import styled from "styled-components"; // your icon component
import { GetIcon } from "../../../icons";
import FormInput from "../../elements/input";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  margin-top: 40px;
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  text-align: left;
  width: 100%;
  // padding-left: 40px;

  @media (max-width: 768px) {
    padding-top: 50px;
  }
`;

const CardContainer = styled.div`
  display: flex;
  gap: 24px;
  justify-content: center;
  flex-wrap: wrap;
`;

const Card = styled.div`
  width: 240px;
  border: ${(props) => props.selected ? "2px solid #3FC4FD" : "2px dashed #d6d6d6"};
  border-radius: 12px;
  padding: 20px 15px;
  text-align: center;
  cursor: pointer;
  transition: 0.25s ease;
  background: #fff;

  &:hover {
    border-color: #3FC4FD;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
  }
`;

const IconBox = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;

  svg {
    width: 48px;
    height: 48px;
    color: #6c6c6c;
  }
`;

const CardTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
`;

const Description = styled.p`
  font-size: 14px;
  color: #555;
  line-height: 1.5;
`;

export default function AccountTypeSelector({ t, onSelect, accountType, onNext }) {

  return (
    <Wrapper>
      <Title>{t("Choose an account type:")}</Title>

      <CardContainer>
        <Card selected={accountType === "company"} onClick={() => onSelect("company")}>
          <IconBox>
            <GetIcon icon="company" />
          </IconBox>
          <CardTitle>{t("Company account")}</CardTitle>
          <Description>
            {t("Create a company account from where you can create a whistleblower channel.")}
          </Description>
        </Card>

        <Card selected={accountType === "partner"} onClick={() => onSelect("partner")}>
          <IconBox>
            <GetIcon icon="partner" />
          </IconBox>
          <CardTitle>{t("Partner account")}</CardTitle>
          <Description>
            {t("Create a partner account from where you can control nested companies.")}
          </Description>
        </Card>
      </CardContainer>

      <FormInput disabled={(!accountType || accountType === null)} type="submit" name="submit" value={t("submit")} onChange={onNext} login={"signupForm"} />
    </Wrapper>
  );
}
